import { render, staticRenderFns } from "./PulpitNieobecne.vue?vue&type=template&id=fb2032b4&scoped=true&"
import script from "./PulpitNieobecne.vue?vue&type=script&lang=js&"
export * from "./PulpitNieobecne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2032b4",
  null
  
)

export default component.exports